import script from "./loginGexView.vue?vue&type=script&setup=true&lang=js"
export * from "./loginGexView.vue?vue&type=script&setup=true&lang=js"

import "./loginGexView.vue?vue&type=style&index=0&id=6aba585e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6aba585e"]])

export default __exports__